<template>
  <v-snackbar :color="getAlert.type" :value="getActive" :multi-line="true" timeout="-1">
    <span v-html="getAlert.message" />
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="removeAlert">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters("alerts", ["getAlert", "getActive"])
  },

  methods: {
    ...mapActions("alerts", ["removeAlert"])
  }
};
</script>

<style>
</style>
